'use strict';

/** Время одной полной итерации анимации, мс. */
const SPIN_TIME_MS = 800;
/** jQuery-селектор спиннера. */
const SPINNER_SELECTOR = '.loader';
/** Класс отображенного спиннера. */
const VISIBLE_SPINNER_CLASS_NAME = 'loader_animated';

// ToDo: перенести на wiki как пример использования jsdoc.
/**
 * Спиннер.
 *
 * @memberOf WebAccess.components.notifications
 */
WebAccess.components.notifications.Spinner = class {
  /**
   * Видимость спиннера.
   *
   * @name Spinner#isVisible
   * @type boolean
   * @readonly
   * @return {boolean} True - спиннер видимый, иначе False.
   */
  get isVisible() {
    return this._isVisible;
  }

  /**
   * Создает объект Spinner.
   *
   * @param {object} [jSpinner = $(SPINNER_SELECTOR)] jQuery-объект спиннера.
   */
  constructor(jSpinner = $(SPINNER_SELECTOR)) {
    /**
     * jQuery-объект спиннера.
     * @type {object}
     */
    this.jSpinner = jSpinner;
    /**
     * ИД таймера.
     * @type {number}
     */
    this.timer = null;
    /**
     * Штамп времени последнего запуска.
     * @type {number}
     */
    this.lastTimestamp = 0;
    /**
     * Признак видимости спиннера.
     * @private
     * @type {boolean}
     * @default false
     */
    this._isVisible = false;
  }

  /**
   * Запуск анимации спиннера.
   *
   * @method Spinner#_start
   * @private
   * @since 5.0.0.7300
   */
  _start() {
    this.jSpinner.removeClass(VISIBLE_SPINNER_CLASS_NAME);
    setTimeout(() => {
      this.lastTimestamp = Date.now();
      this.jSpinner.addClass(VISIBLE_SPINNER_CLASS_NAME);
    }, 0);
    return this;
  }

  /**
   * Отложенный запуск анимации процесса загрузки.
   *
   * @deprecated
   * @method Spinner#showDelayed
   * @param {number} [delay = 500] Задержка запуска анимации в миллисекундах.
   * @return {WebAccess.components.notifications.Spinner} Объект типа Spinner.
   * @since 5.0.0.7300
   */
  showDelayed(delay = 500) {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this._start();
    }, delay);
    return this;
  }

  /**
   * Прекратить отобржение анимации спиннера.
   *
   * @method Spinner#_stop
   * @return {WebAccess.components.notifications.Spinner} Объект типа Spinner.
   * @since 5.0.0.7300
   */
  _stop() {
    setTimeout(() => {
      let timeDiff = Date.now() - this.lastTimestamp;
      let animationStopTimeout = Math.max(Math.ceil(timeDiff / SPIN_TIME_MS) * SPIN_TIME_MS - timeDiff, 0);

      setTimeout((lastTimestamp) => {
        if (!lastTimestamp || lastTimestamp === this.lastTimestamp) {
          this.jSpinner.removeClass(VISIBLE_SPINNER_CLASS_NAME);
        }
      }, animationStopTimeout, this.lastTimestamp);
      return this;
    }, 0);
  }

  /**
   * Показать анимацию процесса загрузки.
   *
   * @method Spinner#show
   * @return {WebAccess.components.notifications.Spinner} Объект типа Spinner.
   * @since 5.0.0.7300
   */
  show() {
    if (!this.jSpinner.length) {
      this.jSpinner = $(SPINNER_SELECTOR);
    }

    // показываем спиннер, если не открыто модальное окно
    if (!window.IsModalShown()) {
      this._isVisible = true;
      this._start();
    }

    return this;
  }

  /**
   * Показать анимацию процесса загрузки в диалоговом окне.
   *
   * @method Spinner#showInDialog
   * @param {number} [delay] Задержка запуска анимации в миллисекундах
   * @return {WebAccess.components.notifications.Spinner} Объект типа Spinner.
   * @since 5.0.0.7300
   */
  showInDialog(delay) {
    let jDialog = $('.ui-dialog:visible, .wizard-form:visible');
    let jDialogLoader = jDialog.find('.ui-dialog-loader');

    if (!jDialogLoader) {
      jDialog.append('<div class="loader ui-dialog-loader" />');
      jDialogLoader = jDialog.find('.ui-dialog-loader');
    }
    this.jSpinner = jDialogLoader;

    if (delay) {
      this.showDelayed(delay);
    } else {
      this.show();
    }

    return this;
  }

  /**
   * Скрыть анимацию процесса загрузки.
   *
   * @method Spinner#hide
   * @param {String} [message] Сообщение о завершении процесса загрузки.
   * @param {number} [delay] Задержка запуска анимации в миллисекундах
   * @param {number} [callback] Функция, которая будет запущена после скрытия анимации.
   * @return {WebAccess.components.notifications.Spinner} Объект типа Spinner.
   * @since 5.0.0.7300
   */
  hide(message, delay, callback) {
    this._isVisible = false;
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (message) {
      let toast = new WA.CMP.NTF.Toast();
      toast.show(message, 'success', null, delay);
    }
    if (callback instanceof Function) {
      setTimeout(() => {
        callback();
      }, delay);
    }
    this._stop();
    return this;
  }
};
